import { gql } from 'graphql-request';

export default gql`query($filter: FeatureFilterInput) {
    features(filter: $filter) {
        items {
            category
            name
            content
            status
            image
            gallery
            products
            order_no
            video
        }
    }
}`;